export class MediaElement{
  id: number;
  isSelected: boolean = false;
  source: string;
  subtitle: string;
  thumb: string;
  title: string;
  fileType: string;
}
